export function getProveedoresOptions(array) {
  let salida = [];
  array.map((p) => {
    salida = [...salida, { value: p.proveedorID, text: p.nombre }];
  });

  return salida;
}
